// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"6bc966f8","398":"b48fe46d","871":"b48fe46d"}[chunkId] + ".chunk.css";
};